const downloadFileFromFetchRequest = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = url
  a.download = filename || 'download'

  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 150)
  }

  a.addEventListener('click', clickHandler, false)
  a.click()
  a.removeEventListener('click', clickHandler)
  a.remove()
}

export default downloadFileFromFetchRequest
